<app-page-header [iconType]="'Chat'" [text]="'Chat Queue'"></app-page-header>

<p>The following merchants are waiting for chat support:</p>

<div>
  <h2>Queue</h2>

  <app-filterable-table
    #chatQueue
    [tableView]="tableView"
    [options]="options"
    (selectedRecord)="handleChatSelected($event)"
  ></app-filterable-table>
</div>
